import { reactive } from "vue";

const issuesByView = reactive(new WeakMap());

export function useStudentRpnIssues(rootElement) {
  function assignmentIssue(assignment) {
    const view = rootElement.value?.closest("[data-student-view]");
    return view ? issuesByView.get(view)?.[assignment?.id] || "" : "";
  }

  function setAssignmentIssues(issues) {
    const view = rootElement.value?.closest("[data-student-view]");
    if (view) issuesByView.set(view, issues || {});
  }

  return { assignmentIssue, setAssignmentIssues };
}
